import * as React from "react";
import {useMemo} from "react";
import {HubFramework} from "../../HubFramework"
import {moduleContent} from "./moduleContent";
import {HubPathRouting} from "../../HubFramework/pathBuilder";
import {ProjectContentDataContext} from "./projectContentDataContext";

const Module: React.FC = () => {
    HubPathRouting.setProject()
    HubPathRouting.clearModule()
    const moduleContext = useMemo(() => ({}), [])
    return (
        <ProjectContentDataContext.Provider value={moduleContext}>
            <HubFramework hubContent={moduleContent} module={moduleContext}/>
        </ProjectContentDataContext.Provider>
    )
}

export default Module;
